import React from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { createSelector } from "reselect";
import { RootState } from "store";

interface OtpSuccessModalProps {
  isOpen: boolean;
  toggle: () => void;
  handleRedirect: any;
}

const OtpSuccessModal: React.FC<OtpSuccessModalProps> = ({
  isOpen,
  toggle,
  handleRedirect,
}) => {
  const selectLeadState = (state: RootState) => state.Lead;

  const selectUserData = createSelector(selectLeadState, (lead) => ({
    SoapResponse: lead?.SoapResponse,
  }));

  const { SoapResponse } = useSelector(selectUserData);
  console.log("SoapResponse", SoapResponse);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const source = queryParams.get("source")?.toLowerCase();
  
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}></ModalHeader>
      <ModalBody className="text-center">
        <i className="mdi mdi-check-circle-outline text-success display-3"></i>
        
        {SoapResponse ? (
          (source === "billpay" || source === "finvesta") ? (
            <>
              <h5 className="mt-3">Customer Registration Successful.</h5>
            </>
          ) : (
          <>
            <h5 className="mt-3">Congratulations 🎉</h5>
            <h5 className="mt-3">You have successfully signed up as an agent.</h5>
            <p className="text-muted">
              Please complete your KYC process to start your business today.
            </p>
          </>
          )
        ) : (
          <>
            <h5 className="mt-3">Details Submitted Successfully 🎉</h5>
            <p className="text-muted">You can now continue with the process.</p>
          </>
        )}
      </ModalBody>
      <ModalFooter className="justify-content-center">
        <Button color="primary" onClick={handleRedirect}>
          Continue
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default OtpSuccessModal;
